module.exports = __webpack_public_path__ + "img/12.ff1991bd.png";